<template lang="pug">
  div
    filter-table(
      layout="text, date"
      :rowSelectedCount="rowsSelected"
      @inputSearchFilter="inputSearchFilter"
      @resetDateFilter="resetDateFilter"
      @paramsDateFilter="paramsDateFilter")
    .credits-table.ods-mt-6
      ods-table(
        v-loading="loadingTable"
        style='width: 100%'
        :data='tableDataRendered'
        :default-sort = "{prop: 'fremesa', order: 'descending'}"
        @selection-change="handleSelectionChange"
        )
        ods-table-column(type='selection' width='55')
        ods-table-column(prop='fecconta' label='Fecha' sortable)
          template(slot-scope="scope")
            div {{ scope.row.fecconta | formatDateLocale }}
        ods-table-column(prop='descodconeco' label='Tipo de comisión' sortable)
        ods-table-column(prop='impconcep' label='Importe comisión' sortable)
          template(slot-scope="scope")
            div {{ scope.row.impconcep | toCurrencyCode(scope.row.clamon) }}
        ods-table-column(prop='impimpto' label='Importe del impuesto' sortable)
          template(slot-scope="scope")
            div {{ scope.row.impimpto | toCurrencyCode(scope.row.clamon) }}

      div.footer
        paginator(
          :isNextPage="indMasDatos"
          :currentPage="currentPage"
          @buttonPrevAction="getPrevPage"
          @buttonNextAction="getNextPage")
        //- ods-pagination.footer__page(
        //- :page-sizes = '[5, 10, 50, 100]',
        //- :page-size = itemsPerPage,
        //- layout='prev, pager, next',
        //- :total='totalData'
        //- @size-change='handleSizeChange',
        //- @current-change='handleCurrentChange'
        //- style="text-align: right; margin-top: 20px")

</template>

<script>
import { mapGetters } from 'vuex'
import FilterTable from '@/components/shared/FilterTable'
import Paginator from '@/components/shared/Paginator'

export default {
  name: 'CommissionsTable',

  components: {
    FilterTable,
    Paginator
  },

  props: {
    comercio: {
      required: true
    }
  },

  data () {
    return {
      defaultParams: { codcom: this.comercio.codcom },
      paginationParams: null,
      tableData: null,
      tableDataRendered: null,
      currentPage: null,
      indMasDatos: null,
      loadingTable: false,
      rowsSelected: null
    }
  },

  computed: {
    ...mapGetters([
      // 'itemsPerPage'
    ])
  },

  methods: {
    async getData (params) {
      this.loadingTable = true
      // Listado Consultas - Comisiones
      await this.$store.dispatch('listCommissions', params)
        .then((res) => {
          this.loadingTable = false
          if (res.registros) {
            this.tableData = Array.isArray(res.registros) ? res.registros : [res.registros]
            this.tableDataRendered = this.tableData
          } else {
            this.tableData = null
            this.tableDataRendered = this.tableData
          }
          this.currentPage = res.pantPagina
          this.indMasDatos = res.indMasDatos
          this.paginationParams = {
            claveInicio: res.claveInicio,
            claveFin: res.claveFin
          }
        })
    },

    getInitialData () {
      const params = {
        ...this.defaultParams
      }
      this.getData(params)
    },

    getPrevPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        retroceder: true
      }
      this.getData(params)
    },

    getNextPage () {
      const params = {
        ...this.defaultParams,
        ...this.paginationParams,
        avanzar: true
      }
      this.getData(params)
    },

    inputSearchFilter (text) {
      this.tableDataRendered = this.tableData.filter((res) => {
        return res.descodconeco.toLowerCase().includes(text.toLowerCase()) ||
          res.impconcep.toString().replace('.', ',').toLowerCase().includes(text.toLowerCase())
      })
    },

    paramsDateFilter (val) {
      const params = {
        ...this.defaultParams,
        ...val
      }
      this.getData(params)
    },

    resetDateFilter () {
      this.getInitialData()
    },

    handleSelectionChange (val) {
      this.rowsSelected = val.length
    }

  },

  mounted () {
    this.getInitialData()
  }
}
</script>

<style lang="scss" scoped>
.notfound {
  margin-top: rem(28)
}

/deep/ .ods-table__row {
  cursor: pointer;
}
</style>
